<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>

                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :tabbed="true"
        :loading="loading"
        title="Electronic Petty Cash List"
        createLink="kasKecilElektronikCreate"
        manifestLink="manifestLaporanKasKecilElektronik"
        editLink="kasKecilElektronikEdit"
        draftEditLink="kasKecilElektronikDraftEdit"
        :dataList="searching"
        :draftList="draftList"
        :price="true"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";

export default {
  name: "ListKasKecil",
  data() {
    return {
      loading: true,
      dataList: [],
      draftList: [],
      kategori: "",
      searchDate: null,
      search: "",
      status: undefined,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getKategori",
      "getDefaultDateFormat",
    ]),
    searching() {
      var self = this;
      let output = this.dataList;

      if (this.search) {
        console.log(this.search);
        output = output.filter(
          (obj) =>
            obj.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.price.indexOf(this.search) >= 0
        );
      }

      if (this.searchDate) {
        let filter = moment(this.searchDate).format("YYYY-MM-DD");
        output = output.filter((obj) => obj.tgl_buat === filter);
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      const laporan = axios({
        method: "get",
        url: this.$serviceUrl + "kas_kecil_elektronik",
        params: {
          tlc: this.getAuth.username,
          jenis: "Laporan",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      const draft = axios({
        method: "get",
        url: this.$serviceUrl + "kas_kecil_elektronik",
        params: {
          tlc: this.getAuth.username,
          jenis: "Draft",
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return axios
        .all([
          laporan.catch((err) => {
            return null;
          }),
          draft.catch((err) => {
            return null;
          }),
        ])
        .then((response) => {
          if (response[0] !== undefined) {
            response[0].data.data.forEach((data) => {
              this.dataList.push({
                title: data.no_kas,
                subdesc: {
                  tanggal: moment(data.tgl_buat).format(
                    this.getDefaultDateFormat
                  ),
                },
                tgl_buat: data.tgl_buat,
                status: data.status,
                id: data.id_kas,
                price: data.grand_total,
                cancelStatus: data.cancel_sts
                  ? data.cancel_sts == 1
                    ? "Canceled"
                    : null
                  : null,
              });
            });
          } else {
            this.dataList = [];
            this.basedList = [];
          }
          if (response[1] !== undefined) {
            response[1].data.data.forEach((data, i) => {
              this.draftList.push({
                title: "Draft " + (i + 1),
                subdesc: [
                  moment(data.tgl_buat).format(this.getDefaultDateFormat),
                ],
                status: data.status,
                id: data.id_kas_draft,
                price: data.grand_total,
              });
            });
          } else {
            this.draftList = [];
          }

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "kas_el",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          //this.fetchData();
          this.$router.go();
          this.searching;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style>
</style>